import Link from 'next/link';

import { Typography } from 'lighthouse';

import { StoresSeeAllCardProps } from './models';

import { ArrowLeft2, Shop } from 'iconsax-react';

export const StoresSeeAllCard = ({ href, total, cityName }: StoresSeeAllCardProps) => (
    <Link
        href={href}
        className='flex h-full min-h-72 flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-primary/40 bg-primary/5 p-6
            text-center no-underline transition-colors hover:border-primary hover:bg-primary/10 focus-visible:outline focus-visible:outline-2
            focus-visible:outline-offset-2 focus-visible:outline-secondary motion-reduce:transition-none'>
        <span className='flex h-14 w-14 items-center justify-center rounded-full bg-white text-primary shadow-sm'>
            <Shop size={26} color='currentColor' variant='Bulk' aria-hidden />
        </span>
        <span className='flex flex-col gap-1'>
            <Typography variant='subtitle1' component='span' color='blackHighEmphasis' className='font-bold leading-7'>
                {total > 0 ? `مشاهده همهٔ ${total.toLocaleString('fa-IR')} فروشگاه` : 'مشاهده همهٔ فروشگاه‌ها'}
            </Typography>
            <Typography variant='caption' component='span' color='blackMediumEmphasis' className='leading-6'>
                با فیلتر شهر، خدمات و امتیاز؛ {cityName}
            </Typography>
        </span>
        <span className='inline-flex items-center gap-1 text-secondary'>
            <Typography variant='body2' component='span' className='font-bold text-current'>
                دیدن لیست کامل
            </Typography>
            <ArrowLeft2 size={16} color='currentColor' aria-hidden />
        </span>
    </Link>
);
